export function transactionErrored(transaction) {
    return 'errorMessage' in transaction;
}
//# sourceMappingURL=TransactionStatus.js.map